module.exports = __webpack_public_path__ + "static/media/RESEARCH-SAMATVAM.8d127a30.pdf";